import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { CurrencyConverterPurePipe } from 'app/shared/currency-converter-pure.pipe';
import { parkMealOf } from 'app/shared/modals/modal-hotel/park-flow/park-display';
import { parkTicketInfo } from 'app/shared/modals/modal-hotel/park-tickets/park-tickets.component';
import { HotelItemComponent } from '../hotel-item/hotel-item.component';

/**
 * Tarjeta del carrito para Parques (categoría 4): hotel, tickets de parque y plan de comidas de la compra.
 * Reutiliza el encabezado, el precio total y los Blickoins de base-item; el detalle de cada habitación es propio.
 * Los datos del ticket y del plan los guarda el modal en room.parkTicket y room.packageCode al agregar al carrito.
 */
@Component({
  selector: 'usb-park-item',
  templateUrl: './park-item.component.html',
  styleUrls: ['./park-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ParkItemComponent extends HotelItemComponent {
  constructor(
    protected cdr: ChangeDetectorRef,
    protected currency: CurrencyConverterPurePipe,
  ) {
    super(cdr, currency);
  }

  ticketOf(room: any): any {
    return room?.room?.parkTicket || room?.parkTicket || null;
  }

  ticketTitle(room: any): string {
    const ticket = this.ticketOf(room);
    return ticket ? parkTicketInfo(this.getParkBrand(), ticket.type)?.title || ticket.name || '' : '';
  }

  mealOf(room: any): string {
    return parkMealOf(room);
  }

  // Los horarios de check in/out vienen como "15:00".
  hs(value: any): string {
    const text = String(value || '').trim();
    return text ? `${text} hs` : 'n/a';
  }

  trackByIndex(index: number): number {
    return index;
  }
}
